enum CaseTypes {
  MVA = 'MVA',
  MedicalMalpractice = 'Medical Malpractice',
  PremisesLiability = 'Premises Liability',
  ProductLiability = 'Product Liability',
  WrongfulDeath = 'Wrongful Death',
  CatastrophicInjury = 'Catastrophic Injury'
};

export default CaseTypes;
